import React, { useState } from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { TabType } from './types';

import { Box, Tab, Tabs } from '@mui/material';

import UnsavedDataAlert from 'components/shared/CRUD/components/InnerPage/components/UnsavedDataAlert';

import { useEditPageContext } from '../../../shared/CRUD/components/InnerPage/EditPage';

import TabSwitcher from './TabSwitcher';

type Props = {
  setCurrentSchema: React.Dispatch<any>;
};

const TabsAtClaSettings = ({ setCurrentSchema }: Props) => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.sectionTitles'
  });
  const { isEditable } = useEditPageContext();
  const [value, setValue] = useState<TabType>(TabType.GENERAL);

  const { formState } = useFormContext();
  const handleChange = (event: React.SyntheticEvent, newValue: TabType) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs value={value} onChange={handleChange}>
        {Object.values(TabType).map((tabItem, index) => {
          return (
            <Tab
              key={index}
              value={tabItem}
              label={t(tabItem)}
              disabled={isEditable}
              component="a"
            />
          );
        })}
      </Tabs>
      {formState.isDirty ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row-reverse'
          }}
        >
          <UnsavedDataAlert />
        </Box>
      ) : (
        ''
      )}
      <TabSwitcher currentTab={value} setCurrentSchema={setCurrentSchema} />
    </>
  );
};

export default TabsAtClaSettings;
